export enum WarehouseStatus {
    Import = 0,
    Export = 1
}